export default "__VITE_ASSET__CjGDBJ0k__"